import { type Attribute, Extension } from "@tiptap/core";
import { isEmpty, isNil } from "lodash-es";

export const htmlAttribute = (name: string): Partial<Attribute> => ({
  default: null,
  parseHTML: (element) => element.getAttribute(name),
  renderHTML: (attributes: Record<string, HTMLElement | undefined>) => {
    const value = attributes[name];
    return isNil(value) ? {} : { [name]: value };
  },
});

// Code taken from the `TextStyle` TipTap extension
const mergeNestedSpanStyles = (element: HTMLElement) => {
  if (isEmpty(element.children)) {
    return;
  }

  const childSpans = element.querySelectorAll("span");
  if (isEmpty(childSpans)) {
    return;
  }

  childSpans.forEach((childSpan) => {
    const childStyle = childSpan.getAttribute("style");
    const closestParentSpanStyleOfChild = childSpan.parentElement?.closest("span")?.getAttribute("style");

    childSpan.setAttribute("style", `${closestParentSpanStyleOfChild};${childStyle}`);
  });
};

export const GlobalHtmlAttributes = Extension.create({
  name: "globalHtmlAttributes",
  addGlobalAttributes: () => [
    {
      types: [
        "blockquote",
        "bold",
        "codeBlock",
        "heading",
        "horizontalRule",
        "image",
        "italic",
        "link",
        "paragraph",
        "strike",
        "table",
        "tableRow",
        "tableCell",
        "tableHeader",
        "textStyle",
        "underline",
        "listItem",
        "bulletList",
        "orderedList",
      ],
      attributes: {
        class: htmlAttribute("class"),
        style: {
          default: null,
          parseHTML: (element) => {
            if (element.nodeName === "SPAN") {
              if (element.hasAttribute("style")) {
                mergeNestedSpanStyles(element);
              }
              return null;
            }
            return element.getAttribute("style") ?? null;
          },
          renderHTML: (attributes) => (isNil(attributes.style) ? {} : { style: attributes.style }),
        },
      },
    },
  ],
});
